import React, { createContext, useState, useContext, ReactNode } from 'react';
import { HeaderBreadcrumb } from '../components/header';

interface BreadcrumbState {
  breadcrumb: Array<HeaderBreadcrumb>;
  setBreadcrumb: (info: Array<HeaderBreadcrumb>) => void;
}

const BreadcrumbContext = createContext<BreadcrumbState | undefined>(undefined);

export const BreadcrumbProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [breadcrumb, setBreadcrumb] = useState<Array<HeaderBreadcrumb>>([]);
  const value = { breadcrumb, setBreadcrumb };

  return (
    <BreadcrumbContext.Provider value={value}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = (): BreadcrumbState => {
  const context = useContext(BreadcrumbContext);
  if (context === undefined) {
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider');
  }
  return context;
};
